<script lang="ts">
import Salarie from '@/extend/classes/Salarie';
import SectionSalarieList from '@/generated/sections/SectionSalarieList.vue';
import { RessourceFwkButton, FwkButtons } from '@/ressources/globalRessources';
import { storeSalarie, storeSession } from '@/generated/stores';
import UserProfile from '@/framework/base/classes/UserProfile';
import { defineComponent } from "vue";
import SearchFilterInput from "@/framework/base/components/SearchFilterInput.vue";
import Route from "@/extend/classes/Route";
import { Fiches, Modules, Sections } from "@/generated/classes/AppSchema";

export default defineComponent({
  components: { SearchFilterInput },
  extends: SectionSalarieList,
  data() {
    const selected: Salarie[] = [];
    return {
      selected,
      dialogOpen: false,
      isCardView: true
    }
  },
  computed: {
    addLabel(): string {
      return RessourceFwkButton(FwkButtons.NEW_SALARIE).label;
    },
    isClient(): boolean {
      let res = false;
      const user = storeSession.connectedUser;
      if (user && user.id > 0) {
        res = UserProfile.isClient;
      }
      return res;
    },
    canAdd(): boolean {
      return this.isClient;
    },
    showToggle(): boolean {
      return true;
    },
    placeholder() {
      return "Rechercher un salarié, pseudo, NSS, e-mail,...";
    },
  },
  methods: {
    selectItemCard(salarie: Salarie): void {
      const obj = salarie;
      const route = new Route();
      route.module = Modules.SALARIE;
      route.fiche = Fiches.SALARIE_ABSTRACT; 
      route.ficheObjId = salarie.id;
      this.$emit('selectItem', route);
    },
    addItem(): void {
      const obj = storeSalarie.createNewSalarie();
      const route = new Route();
      route.module = Modules.SALARIE;
      route.fiche = Fiches.SALARIE_ABSTRACT;
      route.section = Sections.SALARIE;
      route.ficheObjId = obj.id;
      this.$emit('selectItem', route);
    },
    getInitials(salarie: Salarie): string {
      const p = (salarie.prenom ?? '').trim();
      const n = (salarie.nom ?? '').trim();
      const a = p.length > 0 ? p[0] : '';
      const b = n.length > 0 ? n[0] : '';
      return (a + b).toUpperCase();
    },
    getTitle(value: any, objet: any): string {
      return Salarie.getPrenomNom(objet);
    },
    getNewLabel(): string {
      // Libellé affiché sous l'image quand la liste des salariés est vide (mode carte).
      return "Aucun salarié n'est renseigné";
    }
  }
})
</script>
